import React from "react";
import { IoClose } from "react-icons/io5";
import './otp-code-modal.css';
import { Copy } from "lucide-react";
import { showToast } from "../toasts/ToastNotification";

const OtpCodeModal = ({ isOpen, onClose, otp }) => {
  if (!isOpen) return null;

  const copyToClipboard = (text) => {
      showToast("Copy OTP thành công", "success");
    navigator.clipboard.writeText(text);
    onClose();
    };

  return (
    <div className="otp-modal-overlay">
      <div className="otp-modal-card">
        <div className="otp-modal-head">
          <h2 className="otp-modal-title">Lấy OTP thành công</h2>
          <button className="otp-modal-close-btn" onClick={onClose}>
            <IoClose />
          </button>
        </div>
        <div className="otp-modal-body">
          <p className="otp-modal-message">Mã OTP của bạn là:</p>
          <div className="otp-modal-copy-row">
            <p className="otp-modal-code">{otp}</p>
            <button
              type="button"
              onClick={() => copyToClipboard(otp)}
              className="otp-modal-copy-btn"
              aria-label="Copy OTP"
            >
              <Copy className="otp-modal-copy-icon" />
              Copy
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpCodeModal;
